import { render, staticRenderFns } from "./GinSingle.vue?vue&type=template&id=9266dfc0&scoped=true&"
import script from "./GinSingle.vue?vue&type=script&lang=js&"
export * from "./GinSingle.vue?vue&type=script&lang=js&"
import style0 from "./GinSingle.vue?vue&type=style&index=0&id=9266dfc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9266dfc0",
  null
  
)

export default component.exports